function __sdMain(){
/* ===================================================================
   STOREDROP CONFIG — the only three things you have to change.
   =================================================================== */
var CART_URL = (window.STOREDROP && window.STOREDROP.cartUrl) || '/cart';
var CONFIG = {
  WORKER: (window.STOREDROP && window.STOREDROP.workerUrl) || '',
  SHOP: window.location.host,
  VARIANT: {
    ready:  (window.STOREDROP && window.STOREDROP.variantReady)  || '',
    custom: (window.STOREDROP && window.STOREDROP.variantCustom) || ''
  }
};
/* =================================================================== */

(function(){
  var STORES = window.__SD_STORES__ || [];
  var LABEL  = {"pets": "Pet care & training", "sleep": "Sleep & snoring", "fitness": "Home fitness & small-space gym", "recovery": "Muscle recovery & massage", "skincare": "At-home skincare devices", "hair": "Hair care & styling tools", "kitchen": "Kitchen gadgets & cooking", "organisation": "Home organisation & storage", "car": "Car detailing & accessories", "baby": "Baby & toddler", "toys": "Kids toys & learning", "outdoors": "Camping & outdoors", "fishing": "Fishing & angling", "gaming": "Gaming setup & desk", "tech": "Phone & tech accessories", "lighting": "Home lighting & mood decor", "garden": "Garden & indoor plants", "jewellery": "Jewellery & accessories", "wellness": "Yoga & wellness", "travel": "Travel gear & luggage"};
  var BLURB  = {"pets": "Calming vests, lick mats, treat cameras, no-pull harnesses.", "sleep": "Mouth tape, nasal strips, weighted blankets, sunrise alarms.", "fitness": "Adjustable dumbbells, folding benches, doorway bars.", "recovery": "Massage guns, compression boots, cold plunge tubs.", "skincare": "LED masks, microcurrent tools, ice globes, steamers.", "hair": "Detangling brushes, bonnet dryers, diffusers, satin bonnets.", "kitchen": "Choppers, scales, thermometers, frothers, sealers.", "organisation": "Spice risers, fridge bins, dividers, label makers.", "car": "Polishers, foam cannons, detail brushes, clay kits.", "baby": "Suction plates, bottle warmers, nightlights, soothers.", "toys": "Magnetic tiles, busy boards, STEM kits, sensory bundles.", "outdoors": "Camp stoves, sleeping pads, solar banks, lanterns.", "fishing": "Rods, tackle boxes, fish finders, landing nets.", "gaming": "RGB light bars, keyboards, monitor stands, ring lights.", "tech": "Power banks, charging docks, trackers, earbuds.", "lighting": "Galaxy projectors, sunset lamps, LED strips, cloud panels.", "garden": "Self-watering planters, grow lights, moisture meters.", "jewellery": "Name necklaces, birthstone rings, hoop sets.", "wellness": "Cork mats, blocks, diffusers, meditation cushions.", "travel": "Packing cubes, adapters, neck pillows, anti-theft bags."};
  var WHY    = {"pets": "Dog and cat owners, 28-55, emotional buyers, low price sensitivity", "sleep": "30-60, often bought by the partner of the person with the problem", "fitness": "25-45 apartment renters, spec-comparing, budget-aware", "recovery": "25-45, trains 4+ days a week, researches specs before buying", "skincare": "Women 28-50, comparison-shops against Foreo and NuFace", "hair": "18-45, community-driven, high referral rate", "kitchen": "25-55, Facebook and Pinterest driven, buys in sets", "organisation": "Women 25-45, buys full sets, strong before-and-after video", "car": "Men 22-50, enthusiast, buys tools, high repeat rate", "baby": "New parents 25-40, safety-conscious, buys on recommendation", "toys": "Parents and grandparents, seasonal spikes, gift-driven", "outdoors": "25-50, seasonal, gear-obsessed, reads specs", "fishing": "Men 30-65, hobby spenders, buy repeatedly and cheaply", "gaming": "16-30, TikTok-native, buys for how it looks on camera", "tech": "18-40, impulse buyers, very high volume, low AOV", "lighting": "18-35, TikTok interior aesthetic, impulse driven", "garden": "30-65, seasonal, high repeat, strong on Facebook", "jewellery": "Women 18-45, gift-driven, huge Q4 spike", "wellness": "Women 25-50, routine buyers, responds to calm brand voice", "travel": "25-50, seasonal spikes, buys before a trip and in a hurry"};

  var PRICE = { ready:{was:200,now:40,label:'a ready-made store'},
                custom:{was:300,now:60,label:'a custom-built store'} };
  var money = function(n){ return '$' + n; };
  var pct = function(p){ return Math.round((1 - p.now/p.was) * 100); };

  var sel=document.getElementById('niche'), grid=document.getElementById('cards'),
      gTitle=document.getElementById('gridTitle'), gCount=document.getElementById('gridCount'),
      chosen=document.getElementById('chosen'), chTag=document.getElementById('chTag'),
      chName=document.getElementById('chName'), chDesc=document.getElementById('chDesc'),
      stage=document.getElementById('stage'), crate=document.getElementById('crate'),
      tapme=document.getElementById('tapme'), reveal=document.getElementById('reveal'),
      revTitle=document.getElementById('revTitle'), revWas=document.getElementById('revWas'),
      revNow=document.getElementById('revNow'), revPill=document.getElementById('revPill'),
      revWhy=document.getElementById('revWhy'), revCta=document.getElementById('revCta');

  var current = null;

  function render(filter){
    var list = filter ? STORES.filter(function(s){ return s.niche === filter; }) : STORES;
    var html = '';
    list.forEach(function(s){
      html += '<article class="sc">' +
        '<button class="logoplate" type="button" data-prev="' + s.slug + '" ' +
          'data-niche="' + s.niche + '" data-name="' + s.name + '" ' +
          'style="background:' + s.bg + '" aria-label="Preview the ' + s.name + ' store">' + s.logo + '</button>' +
        '<div class="in">' +
          '<span class="eyeb">' + LABEL[s.niche] + '</span>' +
          '<h3>' + s.name + '</h3>' +
          '<p>' + BLURB[s.niche] + '</p>' +
          '<span class="cnt">' + s.n + ' products &middot; own brand &amp; logo</span>' +
          '<div class="acts">' +
            '<button class="open" type="button" data-prev="' + s.slug + '" ' +
              'data-niche="' + s.niche + '" data-name="' + s.name + '">Open store &nearr;</button>' +
            '<button class="pickme" data-pick="' + s.niche + '" type="button">Claim one &rarr;</button>' +
          '</div>' +
        '</div></article>';
    });
    grid.innerHTML = html;
    gTitle.textContent = filter ? LABEL[filter] : 'All ' + STORES.length + ' stores';
    gCount.textContent = list.length + ' available';
  }
  render(null);

  // ---- live stock ------------------------------------------------------
  // Asks the worker what is actually left, then removes sold stores from the
  // grid and disables sold-out niches in the dropdown. Without this the site
  // will happily sell a niche that ran out an hour ago.
  var SOLD = {};
  function applyStock(){
    if (!CONFIG.WORKER) return;
    fetch(CONFIG.WORKER.replace(/\/$/,'') + '/stock')
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(d){
        if (!d || !d.niches) return;
        var totalLeft = 0;
        Object.keys(d.niches).forEach(function(k){
          var n = d.niches[k];
          totalLeft += n.available;
          if (n.available === 0){
            SOLD[k] = true;
            for (var i=0;i<sel.options.length;i++){
              if (sel.options[i].value === k){
                sel.options[i].disabled = true;
                sel.options[i].text += '  (sold out)';
              }
            }
          }
        });
        // reflect real numbers in the ticker and grid header
        document.querySelectorAll('[data-livecount]').forEach(function(el){
          el.textContent = totalLeft;
        });
        if (!current) gCount.textContent = totalLeft + ' available';
      })
      .catch(function(){ /* worker down: leave the static page alone */ });
  }
  applyStock();

  // ---- analytics (optional) -------------------------------------------
  function track(event, data){
    if (window.plausible) window.plausible(event, {props: data || {}});
    if (window.gtag) window.gtag('event', event, data || {});
  }

  function armCrate(){
    crate.classList.remove('open','drop');
    reveal.classList.remove('on');
    tapme.style.display = '';
    void crate.offsetWidth;
    stage.classList.add('on');
    crate.classList.add('drop');
  }

  function choose(key){
    current = key;
    if (key === 'custom'){
      chTag.textContent = 'Custom build';
      chName.textContent = 'Your own idea';
      chDesc.textContent = 'Tell us the niche and we research it, pick the products, invent the brand name, draw the logo and build the whole thing from scratch. It never goes on the list, so it stays yours alone.';
      render(null);
    } else {
      chTag.textContent = LABEL[key];
      chName.textContent = LABEL[key];
      chDesc.textContent = BLURB[key] + ' ' + WHY[key] + '.';
      render(key);
    }
    chosen.classList.add('on');
    track('niche_selected', {niche: key});
    armCrate();
    setTimeout(function(){ stage.scrollIntoView({behavior:'smooth', block:'center'}); }, 120);
  }

  sel.addEventListener('change', function(){
    if (!sel.value){ chosen.classList.remove('on'); stage.classList.remove('on'); render(null); return; }
    choose(sel.value);
  });

  window.sdChooseNiche = function(k){ sel.value = k; choose(k); };

  grid.addEventListener('click', function(e){
    var pv = e.target.closest('[data-prev]');
    if (pv && window.sdOpenPreview){
      window.sdOpenPreview(pv.getAttribute('data-prev'), pv.getAttribute('data-niche'),
                           pv.getAttribute('data-name'), LABEL[pv.getAttribute('data-niche')]);
      return;
    }
    var b = e.target.closest('[data-pick]');
    if (!b) return;
    sel.value = b.getAttribute('data-pick');
    choose(sel.value);
  });

  document.querySelectorAll('[data-jump]').forEach(function(el){
    el.addEventListener('click', function(ev){
      ev.preventDefault();
      if (el.getAttribute('data-jump') === 'custom'){ sel.value='custom'; choose('custom'); }
      else { document.getElementById('picker').scrollIntoView({behavior:'smooth', block:'center'}); }
    });
  });

  revCta.addEventListener('click', function(){ track('checkout_clicked', {niche: current || 'any'}); });

  crate.addEventListener('click', function(){
    if (crate.classList.contains('open')) return;
    crate.classList.add('open');
    tapme.style.display = 'none';

    var p = (current === 'custom') ? PRICE.custom : PRICE.ready;
    revTitle.textContent = 'Congratulations \u2014 ' + pct(p) + '% off';
    revWas.textContent = money(p.was);
    revNow.textContent = money(p.now);
    revPill.textContent = 'Save ' + money(p.was - p.now);
    revWhy.textContent = 'That is the launch price for ' + p.label +
      '. It goes to ' + money(p.was) + ' once the first hundred stores are gone.';

    /* Build the checkout link. If no variant was found we must NOT emit
       '/cart/:1' — that is a dead URL and lands the buyer on a 404. */
    var vid = (current === 'custom') ? CONFIG.VARIANT.custom : CONFIG.VARIANT.ready;
    vid = String(vid == null ? '' : vid).replace(/[^0-9]/g, '');

    if (vid) {
      revCta.href = CART_URL + '/' + vid + ':1' +
        '?attributes[Niche]=' + encodeURIComponent(current || 'any') +
        '&attributes[Package]=' + encodeURIComponent(current === 'custom' ? 'Custom' : 'Ready-made');
      revCta.textContent = 'Checkout \u2014 get it emailed to me';
      revCta.removeAttribute('aria-disabled');
      revCta.classList.remove('btn-off');
    } else {
      revCta.removeAttribute('href');
      revCta.textContent = 'Checkout is not connected yet';
      revCta.setAttribute('aria-disabled', 'true');
      revCta.classList.add('btn-off');
    }

    track('price_revealed', {niche: current || 'any'});
    setTimeout(function(){
      reveal.classList.add('on');
      setTimeout(function(){ reveal.scrollIntoView({behavior:'smooth', block:'center'}); }, 120);
    }, 420);
  });
})();

}

function __sdSupport(){
(function(){
  // Set this to your support worker URL. Left empty, the widget stays hidden.
  var SUPPORT_URL = (window.STOREDROP && window.STOREDROP.supportUrl) || '';

  var chat=document.getElementById('sdChat');
  if(!SUPPORT_URL){ chat.style.display='none'; return; }

  var btn=document.getElementById('sdBtn'), close=document.getElementById('sdClose'),
      log=document.getElementById('sdLog'), form=document.getElementById('sdForm'),
      input=document.getElementById('sdIn'), sug=document.getElementById('sdSuggest');
  var history=[], opened=false;

  function add(text, who){
    var d=document.createElement('div');
    d.className='sdMsg '+who; d.textContent=text;
    log.appendChild(d); log.scrollTop=log.scrollHeight;
    return d;
  }

  var STARTERS=['How much does it cost?','How do I get my store?',
                'What if I change my mind?','Do I need to know coding?'];
  function starters(){
    sug.innerHTML='';
    STARTERS.forEach(function(q){
      var b=document.createElement('button'); b.type='button'; b.textContent=q;
      b.onclick=function(){ sug.innerHTML=''; send(q); };
      sug.appendChild(b);
    });
  }

  function open(){
    chat.classList.add('open');
    if(!opened){
      opened=true;
      add("Hey. Ask me anything about how this works, what it costs, or what happens after you buy."
          +"\n\nIf I don't know something I'll pass you to a person rather than guess.", 'bot');
      starters();
    }
    input.focus();
  }
  btn.onclick=open;
  close.onclick=function(){ chat.classList.remove('open'); };

  function send(q){
    add(q,'me');
    history.push({role:'user',content:q});
    var t=add('typing\u2026','bot typing');
    fetch(SUPPORT_URL.replace(/\/$/,'')+'/ask',{
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({question:q, history:history})
    }).then(function(r){ return r.json(); })
      .then(function(d){
        t.remove();
        var a = d.answer || "Something went wrong. Email hello@storedrop.co and we'll help.";
        add(a,'bot');
        history.push({role:'assistant',content:a});
        if(window.plausible) window.plausible('support_question',{props:{source:d.source||'?'}});
      })
      .catch(function(){
        t.remove();
        add("I can't reach the server. Email hello@storedrop.co and a person will help.",'bot');
      });
  }

  form.onsubmit=function(e){
    e.preventDefault();
    var q=input.value.trim();
    if(!q) return;
    input.value=''; sug.innerHTML='';
    send(q);
  };
})();

}


/* ---- store preview modal -------------------------------------------------
   Previews live in one JSON per niche, fetched only when someone clicks a
   store. About 110 KB each instead of one 2.2 MB blob up front.            */
(function(){
  var box=document.getElementById('sdPrev');
  if(!box) return;
  var frame=document.getElementById('sdPrevFrame'),
      nameEl=document.getElementById('sdPrevName'),
      nicheEl=document.getElementById('sdPrevNiche'),
      load=document.getElementById('sdPrevLoad'),
      claim=document.getElementById('sdPrevClaim'),
      close=document.getElementById('sdPrevClose');
  var cache={}, currentNiche=null;

  function hide(){ box.classList.remove('on'); frame.srcdoc=''; document.body.style.overflow=''; }
  close.onclick=hide;
  box.onclick=function(e){ if(e.target===box) hide(); };
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') hide(); });

  claim.onclick=function(){
    hide();
    if(currentNiche && window.sdChooseNiche) window.sdChooseNiche(currentNiche);
  };

  window.sdOpenPreview=function(slug,niche,name,label){
    currentNiche=niche;
    nameEl.textContent=name;
    nicheEl.textContent=label||'';
    load.style.display='grid';
    frame.srcdoc='';
    box.classList.add('on');
    document.body.style.overflow='hidden';

    function show(html){
      load.style.display='none';
      frame.srcdoc=html||'<p style="font-family:sans-serif;padding:40px">'
        +'Preview unavailable. The store itself is fine.</p>';
    }
    if(cache[niche]){ show(cache[niche][slug]); return; }

    var url=(window.STOREDROP.previewBase||'').replace('NICHE',niche);
    fetch(url).then(function(r){ return r.json(); })
      .then(function(d){ cache[niche]=d; show(d[slug]); })
      .catch(function(){ show(null); });
  };
})();

/* Loads the store data, then boots the page. */
(function(){
  var u = (window.STOREDROP && window.STOREDROP.storesUrl) || '';
  function go(list){ window.__SD_STORES__ = list || []; __sdMain(); __sdSupport(); }
  if(!u){ go([]); return; }
  fetch(u).then(function(r){ return r.json(); }).then(go).catch(function(){ go([]); });
})();

/* ---- mobile menu ----------------------------------------------------------
   The header nav is hidden under 1000px. This drives the hamburger that
   replaces it. Purely additive; desktop behaviour is unchanged.            */
(function(){
  var burger = document.getElementById('burger'),
      nav    = document.getElementById('mobnav');
  if(!burger || !nav) return;
  var header = burger.closest('header.site') || document.querySelector('header.site');
  if(!header) return;

  function setOpen(open){
    header.classList.toggle('nav-open', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  }

  burger.addEventListener('click', function(){
    setOpen(!header.classList.contains('nav-open'));
  });

  /* tapping any link closes the menu so the page can scroll to the anchor */
  nav.addEventListener('click', function(e){
    if(e.target.closest('a')) setOpen(false);
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') setOpen(false);
  });

  /* tapping outside the header closes it too */
  document.addEventListener('click', function(e){
    if(header.classList.contains('nav-open') && !header.contains(e.target)) setOpen(false);
  });

  /* if the window grows back to desktop, drop the mobile state */
  var mq = window.matchMedia('(min-width:1001px)');
  var onChange = function(e){ if(e.matches) setOpen(false); };
  if(mq.addEventListener) mq.addEventListener('change', onChange);
  else if(mq.addListener) mq.addListener(onChange);
})();
